import { Component, FC, PropsWithChildren } from "react"

interface ErrorBoundaryProps {
    system?: string
    errorGeneral: string
    tryAgain: string
}

export class ErrorBoundaryBase extends Component<PropsWithChildren<ErrorBoundaryProps>> {
    state = {
        error: false,
    }
    componentDidCatch(error: Error) {
        this.setState({
            error,
        })
    }

    render() {
        const { children, system, errorGeneral, tryAgain } = this.props
        if (this.state.error) {
            return (
                <div
                    style={{
                        background: "#f1dede",
                        margin: "10px",
                        padding: "10px",
                        textAlign: "center",
                    }}>
                    <h1>
                        {errorGeneral} {system || "system"} <br />
                        {tryAgain}
                    </h1>
                </div>
            )
        }
        return children
    }
}

export class LayoutErrorBoundary extends Component<PropsWithChildren<{ Fallback: FC<{ error: Error | null }> }>> {
    state: { error: null | Error } = {
        error: null,
    }
    componentDidCatch(error: Error) {
        this.setState({
            error,
        })
        console.error(error)
    }
    render() {
        const { children } = this.props
        if (this.state.error) {
            const Fallback = this.props.Fallback
            return <Fallback error={this.state.error} />
        }
        return children
    }
}
